import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { IsUser } from '../interfaces/is-user';
import { Endpoints, EndpointType } from '../types/endpoints';
import { AuthService } from './auth.service';
import { IsUserDetails } from '../interfaces/is-user-details';
import { UserOptionsType } from '../types/user-options';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	// Url settings
	private readonly api: string = environment.api;
	private readonly endpoint: EndpointType = Endpoints.USER_DETAILS;

	// Injections
	private readonly http: HttpClient = inject(HttpClient);
	private readonly authService: AuthService = inject(AuthService);

	// User
	private userDetails: IsUserDetails | undefined;

	public get user(): Observable<IsUser | undefined> {
		return this.authService.user;
	}

	public getUserDetails(): Observable<IsUserDetails | undefined> {
		// Check if user is already loaded
		if (this.userDetails) {
			// Return user details as observable
			return of(this.userDetails);
		} else {
			// Make request to get user details
			return this.http.get<IsUserDetails>(`${this.api}/${this.endpoint}`).pipe(
				// Store user details
				tap((userDetails: IsUserDetails) => {
					this.userDetails = userDetails;
				})
			);
		}
	}

	public userHasOption(user: IsUser, option: UserOptionsType): boolean {
		return !!user?.options?.includes(option + '');
	}
}
